import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../../../../api/queries/apiGet';
import { API_BASE_URL } from '../constants/consts';
import { universalMFAQueryKeys } from '../constants/queryKeys';
import type { ApiError } from '../types';
import { PolicyCountByStatus } from '../../types';

const END_POINT = '/metric/bridgeMfaPolicies';

type BridgeMfaPoliciesDto = PolicyCountByStatus;

const convertToBridgeMfaPolicies = (data: BridgeMfaPoliciesDto): PolicyCountByStatus => {
    return {
        total: data.total,
        active: data.active,
        disabled: data.disabled
    };
};

const fetchBridgeMfaPolicies = async (): Promise<BridgeMfaPoliciesDto> => {
    const data = await apiGet<BridgeMfaPoliciesDto>(`${API_BASE_URL}${END_POINT}`);
    return data;
};

export const useBridgeMfaPolicies = (): UseQueryResult<PolicyCountByStatus, ApiError> => {
    return useQuery({
        queryKey: universalMFAQueryKeys.bridgeMfaPolicies(),
        queryFn: () => fetchBridgeMfaPolicies(),
        select: convertToBridgeMfaPolicies
    });
};
